import { render, staticRenderFns } from "./DefBody.vue?vue&type=template&id=686d67da&scoped=true"
import script from "./DefBody.vue?vue&type=script&lang=js"
export * from "./DefBody.vue?vue&type=script&lang=js"
import style0 from "./DefBody.vue?vue&type=style&index=0&id=686d67da&prod&lang=less&scoped=true"
import style1 from "./DefBody.vue?vue&type=style&index=1&id=686d67da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686d67da",
  null
  
)

export default component.exports